export default __webpack_public_path__ + "static/media/assets-layout-evolution.ba99bc95.jpg";